import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../utils/immutable";
import { IAction } from "../../../models/Action";
import { IAttachment } from "../../../models/Attachment";
import moment from "moment";
import FileSaver from "file-saver";

import {
  ATTACHMENT_LIST_IDENTIFIER,
  ATTACHMENT_TABS_IDENTIFIER,
  CALL_STATE_IDENTIFIER,
} from "./constants";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { convertBase64ToBlob } from "../../../common/ManualsUtils/ManualsServices";

const ACTION_HANDLERS = {
  [actionTypes.PANEL_TAB_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([ATTACHMENT_TABS_IDENTIFIER], action.payload, state),
  [actionTypes.PANEL_TAB_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([ATTACHMENT_TABS_IDENTIFIER], []),

  [actionTypes.PANEL_TAB_ATTACHMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const tempAttachment: IAttachment[] = [];
    action.payload.forEach((attach: any) =>
      tempAttachment.push({
        attachId: attach.id,
        deleteAllowed: attach.deleteAllowed,
        name: attach.name,
        size: ((attach.size as number) / 1000).toFixed(2) + " KB",
        uploadDate: attach.uploadDate
          ? moment(attach.uploadDate).format("DD/MM/YYYY - HH:mm")
          : "",
      })
    );
    return immutableSet([ATTACHMENT_LIST_IDENTIFIER], tempAttachment, state);
  },
  [actionTypes.PANEL_TAB_ATTACHMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([ATTACHMENT_LIST_IDENTIFIER], null, state),

  [actionTypes.DOWNLOAD_ATTACHMENT_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER], IResponseState.PENDING, state),
  [actionTypes.DOWNLOAD_ATTACHMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const fileName: string = action.payload.request.name;
    action.payload.response.text().then((base64: any) => {
      const blob = convertBase64ToBlob(base64);
      FileSaver.saveAs(blob, fileName);
    });

    return immutableSet([CALL_STATE_IDENTIFIER], IResponseState.SUCCESS, state);
  },
  [actionTypes.DOWNLOAD_ATTACHMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE_IDENTIFIER], IResponseState.ERROR, state),

  [actionTypes.DELETE_ATTACHMENT_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER], IResponseState.PENDING, state),
  [actionTypes.DELETE_ATTACHMENT_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER], IResponseState.SUCCESS, state),
  [actionTypes.DELETE_ATTACHMENT_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER], IResponseState.ERROR, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
